import React, { FunctionComponent } from 'react';
import NPCForm from './NPCForm/NPCForm';
import useStyles from './NewPasswordChallenge.styles';

const NewPasswordChallenge: FunctionComponent = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <NPCForm />
    </div>
  );
};

export default NewPasswordChallenge;
